import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const sideDrawerFooter = ({ theme }: { theme: Theme }) => css`
  flex-grow: 1;
  width: 100%;
  background: linear-gradient(to bottom, transparent 40%, ${theme.palette.primary.main}20 100%);
  margin: ${theme.spacing(2, 0, 0, 0)};
`
